import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDashboardApi } from "helpers/ApiManager";
import { ApiResponse } from "types/ApiResponse";
import { DashboardApiPayload } from "types/dashboard.api";

export const getDashboard = createAsyncThunk<
  ApiResponse<DashboardApiPayload>, // return type
  undefined, // argument type
  { rejectValue: string } // rejected type
>("dashboard/getDashboard", async (_params, { rejectWithValue }) => {
  try {
    const response = await getDashboardApi();
    console.log("response", JSON.stringify(response.requestId, null, 2));
    console.log("dashBoard Response", response);

    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});
